// frontend/src/samkalp-faculty/liveSessions/MySessionsPage.js
//
// Faculty's own scheduled/live/completed sessions, plus the Schedule form.
// Polling (not sockets — no WebSocket precedent anywhere in this app) keeps
// the list fresh while a session is live.
import React, { useCallback, useEffect, useState } from 'react';
import { Badge, Button, Card, Tab, Tabs } from 'react-bootstrap';
import ScheduleSessionForm from './ScheduleSessionForm';
import SessionDetailPanel from './SessionDetailPanel';
import { listMyLiveSessions } from '../../api/liveSessionsApi';

const STATUS_VARIANT = { scheduled: 'secondary', live: 'danger', completed: 'success', cancelled: 'dark' };
const TABS = [
    { key: 'scheduled', label: 'Upcoming' },
    { key: 'live', label: 'Live Now' },
    { key: 'completed', label: 'Completed' },
];

const MySessionsPage = ({ slug }) => {
    const [activeTab, setActiveTab] = useState('scheduled');
    const [sessions, setSessions] = useState([]);
    const [selectedId, setSelectedId] = useState(null);
    const [showSchedule, setShowSchedule] = useState(false);

    const load = useCallback(() => {
        listMyLiveSessions(slug, activeTab).then(setSessions).catch(() => setSessions([]));
    }, [slug, activeTab]);

    useEffect(() => {
        load();
        const interval = setInterval(load, 15000);
        return () => clearInterval(interval);
    }, [load]);

    const selected = sessions.find(s => s.id === selectedId);

    return (
        <div className="my-sessions-page">
            <div className="d-flex justify-content-between align-items-center mb-3">
                <h4 className="fw-bold mb-0">My Live Sessions</h4>
                <Button onClick={() => setShowSchedule(o => !o)}>{showSchedule ? 'Close' : '+ Schedule Session'}</Button>
            </div>

            {showSchedule && (
                <Card className="mb-4 p-3">
                    <ScheduleSessionForm slug={slug} onScheduled={() => { setShowSchedule(false); setActiveTab('scheduled'); load(); }} />
                </Card>
            )}

            <Tabs activeKey={activeTab} onSelect={k => { setActiveTab(k); setSelectedId(null); }} className="mb-3">
                {TABS.map(t => <Tab key={t.key} eventKey={t.key} title={t.label} />)}
            </Tabs>

            {sessions.length === 0 && <p className="text-muted">No sessions here yet.</p>}

            <div className="sessions-list">
                {sessions.map(s => (
                    <Card key={s.id} className="mb-2 session-row">
                        <Card.Body className="d-flex justify-content-between align-items-center" style={{ cursor: 'pointer' }}
                            onClick={() => setSelectedId(prev => prev === s.id ? null : s.id)}>
                            <div>
                                <strong>{s.topic}</strong>
                                <div className="small text-muted">{s.subject_label} &middot; {new Date(s.scheduled_start_utc).toLocaleString()} &middot; {s.duration_minutes} min</div>
                            </div>
                            <Badge bg={STATUS_VARIANT[s.status] || 'secondary'} className="text-uppercase">{s.status}</Badge>
                        </Card.Body>
                        {selectedId === s.id && (
                            <Card.Footer>
                                <SessionDetailPanel slug={slug} session={s} onChanged={load} />
                            </Card.Footer>
                        )}
                    </Card>
                ))}
            </div>
        </div>
    );
};

export default MySessionsPage;
